@if (isLoading && !cifrasWebSego) {
  <div class="bg-primary-900 p-4">
    <app-is-loading [color]="'neutral-0'" [type]="'text'"></app-is-loading>
  </div>
}

<!--#region Segofinance -->
@if (plataformaId === 'SEGOFINANCE') {
  @if (!isLoading && cifrasWebSego) {
    <div id="estadisticas-segofinance" class="p-5 bg-primary-900 primary-50 fadein">
      <div class="container px-lg-2 px-xl-5">
        <div class="row d-flex align-items-center">
          <div class="col-12 col-lg-5  text-center text-lg-start mb-cifras mb-lg-0">
            <h1 class="p1-cifras h1-bold mb-0">Una red de más de <br><span contador
            [contadorConfig]="{endValue: cifrasWebSego.inversores}"></span>k inversores</h1>
          </div>
          <div class="col-12 col-lg-7">
            <div class="row">
              <div class="col-12 col-lg-4 text-center mb-3 mb-lg-0">
                <p class="p1-cifras">+<span contador
                [contadorConfig]="{endValue: cifrasWebSego.inversiones}"></span></p>
                <p class="p1-medium">Inversiones al día</p>
              </div>
              <div class="col-12 col-lg-4 text-center mb-3 mb-lg-0">
                <p class="p1-cifras">+<span contador
                [contadorConfig]="{endValue: cifrasWebSego.invertidos}"></span>M€</p>
                <p class="p1-medium">Invertidos</p>
              </div>
              <div class="col-12 col-lg-4 text-center">
                <p class="p1-cifras">+<span contador
                [contadorConfig]="{endValue: cifrasWebSego.operaciones}"></span></p>
                <p class="p1-medium ">Operaciones realizadas</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}
<!-- #endregion -->

<!--#region ProductosCNMV -->
@if (plataformaId === 'VENTURE' || plataformaId === 'REALESTATE' || plataformaId === 'CREATIVE') {
  @if (!isLoading) {
    <div id="estadisticas-segofinance-participadas" class="container-fluid p-4 bg-primary-900 primary-50">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-4 text-center border-right-2 border-primary-50 d-flex flex-column align-items-center mb-3 mb-lg-0">
            <p class="p1-cifras"><span contador
            [contadorConfig]="{endValue: cifrasWebSego?.empresasCotizadas}"></span></p>
            <p class="p1-bold primary-300">Empresas cotizadas</p>
          </div>
          <div class="col-lg-4 text-center d-flex flex-column align-items-center">
            <p class="p1-cifras">+<span contador
            [contadorConfig]="{endValue: cifrasWebSego?.inversoresRegistrados}"></span></p>
            <p class="p1-bold primary-300">Inversores registrados</p>
          </div>
        </div>
      </div>
    </div>
  }
}
<!-- #endregion -->

<!--#region Factoring -->
@if (plataformaId === 'FACTORING') {
  @if (!isLoading) {
    <div id="estadisticas-segofinance-factoring" class="container-fluid bg-primary-900 primary-50">
      <div class="container">
        <div class="row py-4">
          <div class="col-lg-4 text-center border-right-2 border-primary-50 d-flex flex-column align-items-center mb-3 mb-lg-0">
            <p class="p1-cifras">+<span contador
            [contadorConfig]="{endValue: cifrasWebSego?.financiados}"></span>M€</p>
            <p class="p1-bold primary-300">Financiados</p>
          </div>
          <div class="col-lg-4 text-center border-right-2 border-primary-50 d-flex flex-column align-items-center mb-3 mb-lg-0">
            <p class="p1-cifras">+<span contador
            [contadorConfig]="{endValue: cifrasWebSego?.operaciones}"></span></p>
            <p class="p1-bold primary-300">Operaciones</p>
          </div>
          <div class="col-lg-4 text-center d-flex flex-column align-items-center">
            <p class="p1-cifras"><span contador
            [contadorConfig]="{endValue: cifrasWebSego?.rentabilidadMedia}"></span>%</p>
            <p class="p1-bold primary-300">Rentabilidad media</p>
          </div>
        </div>
      </div>
    </div>
  }
}
<!-- #endregion -->

<!--#region Funds -->
@if (plataformaId === 'FUNDS') {
  @if (!isLoading) {
    <div id="estadisticas-segofinance-funds" class="container-fluid bg-primary-900 primary-50">
      <div class="container">
        <div class="row py-4">
          <div class="col-lg-4 text-center border-right d-flex flex-column align-items-center mb-3 mb-lg-0">
            <p class="p1-bold primary-300">Cuenta remunerada</p>
            <p class="p1-cifras">+<span contador
            [contadorConfig]="{endValue: cifrasWebSego?.cuentaRemunerada, isDecimal : true}"></span>%
          </p>
        </div>
        <div class="col-lg-4 text-center border-right d-flex flex-column align-items-center mb-3 mb-lg-0">
          <p class="p1-bold primary-300">Depósitos hasta el</p>
          <p class="p1-cifras"><span contador
          [contadorConfig]="{endValue: cifrasWebSego?.depositos, isDecimal : true}"></span>%</p>
        </div>
        <div class="col-lg-4 text-center d-flex flex-column align-items-center">
          <p class="p1-bold primary-300">Carteras con comisiones muy bajas</p>
          <p class="p1-cifras">
            <span contador [contadorConfig]="{endValue: cifrasWebSego?.carteras, isDecimal : true}"></span>%
            <span class="p2-medium">custodia y gestión</span>
          </p>
        </div>
      </div>
    </div>
  </div>
}
}
<!-- #endregion -->